import FilterClickAction from "./FilterClickAction.js";
import FiltersClickAction from "./FiltersClickAction.js";
import GeoDistanceClickAction from "./GeoDistanceClickAction.js";
import HistogramClickAction from "./HistogramClickAction.js";
import NoFilterClickAction from "./NoFilterClickAction.js";
import RangeClickAction from "./RangeClickAction.js";
import TermsClickAction from "./TermsClickAction.js";
import { createFilterFilter, createFiltersFilter, createGeoDistanceRangeFilter, createHistogramFilter, createRangeFilter, createTermsConditionFilter } from "./Util.js";
export default {
  install(molten) {
    molten.addPlugin('AggClickAction', TermsClickAction);
    molten.addPlugin('AggClickAction', FiltersClickAction);
    molten.addPlugin('AggClickAction', FilterClickAction);
    molten.addPlugin('AggClickAction', GeoDistanceClickAction);
    molten.addPlugin('AggClickAction', HistogramClickAction);
    molten.addPlugin('AggClickAction', RangeClickAction);
    molten.addPlugin('AggClickAction', NoFilterClickAction);
    molten.addPlugin('AggFilterCreator', {
      type: createGeoDistanceRangeFilter.TYPE,
      getFilter: createGeoDistanceRangeFilter
    });
    molten.addPlugin('AggFilterCreator', {
      type: createHistogramFilter.TYPE,
      getFilter: createHistogramFilter
    });
    molten.addPlugin('AggFilterCreator', {
      type: createRangeFilter.TYPE,
      getFilter: createRangeFilter
    });
    molten.addPlugin('AggFilterCreator', {
      type: createTermsConditionFilter.TYPE,
      getFilter: createTermsConditionFilter
    });
    molten.addPlugin('AggFilterCreator', {
      type: createFilterFilter.TYPE,
      getFilter: createFilterFilter
    });
    molten.addPlugin('AggFilterCreator', {
      type: createFiltersFilter.TYPE,
      getFilter: createFiltersFilter
    });
  }
};